module.exports = __webpack_public_path__ + "img/character-01.1b4b8853.png";